import React from 'react'
import ReactMarkdown from 'utils/markdown'
import SectionType from 'models/types/ts/sectionType'
import { Visibility } from 'layouts'
import { Heading } from 'layouts/headings'
import { ParagraphRegular } from 'layouts/typography'
import style from './RecruiterRewards.module.scss'

interface Props {
    section: SectionType
}

const RecruiterRewards = ({ section }: Props): JSX.Element => {
    const {
        headline,
        body,
        contentCollection: { items, total },
    } = section
    return (
        <div className={style.wrapper}>
            <Heading isRecruit size="small">
                {headline}
            </Heading>
            <ParagraphRegular>{body}</ParagraphRegular>
            <div className={style.recruitFriends}>
                {total > 0 &&
                    items.map((item) => (
                        <Visibility key={item.name} className={style.content}>
                            <img alt="" src={item.imageFile.url} />
                            <h3 className={style.title}>{item.headline}</h3>
                            <ReactMarkdown
                                source={item.body}
                                renderers={{
                                    p: ({ children }) => (
                                        <ParagraphRegular>
                                            {children}
                                        </ParagraphRegular>
                                    ),
                                }}
                            />
                        </Visibility>
                    ))}
            </div>
        </div>
    )
}

export default RecruiterRewards
